
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Annahme: Durchschnittliche Auslastung des Autos mit 1,6 Personen und etwa 10’000 km Fahrleistung pro Jahr. Mitberücksichtigt wurden auch der Bau des Fahrzeugs und der Strasse sowie die Emissionen bei der Gewinnung des Rohöls für die Herstellung des Treibstoffs.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;